import { StyleSheet } from '@react-pdf/renderer';

export const IncidentReportStyles = StyleSheet.create({
	page: {
		flexDirection: 'column',
		backgroundColor: '#E4E4E4',
		fontSize: 12,
		paddingTop: 30,
		paddingBottom: 65,
		paddingHorizontal: 35,
	},
	headerWrapper: {
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
		flexDirection: 'row',
	},
	logo: {
		width: 150,
		objectFit: 'contain',
		marginBottom: 10,
	},
	headerText: {
		fontSize: 20,
		fontWeight: 'bold',
		color: '#ab131d',
		maxWidth: '80%',
	},
	spacedApartLineWrapper: {
		padding: 5,
		paddingHorizontal: 20,
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
		flexDirection: 'row',
	},
	spacedApartLineTextWrapper: {
		flexDirection: 'row',
		alignItems: 'center',
	},
	redContainer: {
		flexDirection: 'row',
		backgroundColor: '#ab131d',
		paddingVertical: 3,
		marginVertical: 10,
		justifyContent: 'center',
		alignItems: 'center',
	},
	redContainerText: {
		color: '#ffffff',
		fontSize: 14,
		fontWeight: 'bold',
		textTransform: 'uppercase',
	},
	checkpointContainer: {
		paddingHorizontal: 20,
		marginVertical: 5,
		gap: 10,
		display: 'flex',
		flexDirection: 'column',
	},
	checkpointName: {
		color: '#ab131d',
	},
	checkpointImagesWrapper: {
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'space-evenly',
		flexWrap: 'wrap',
		alignItems: 'flex-start',
	},
	checkpointImageWrapper: {
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		flexDirection: 'column',
		gap: 5,
	},
	checkpointImage: {
		maxHeight: 150,
		maxWidth: 150,
		objectFit: 'contain',
	},
	checkpointSignatureContainer: {
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'space-between',
		width: '100%',
	},
	checkpointSignatureWrapper: {
		display: 'flex',
		alignItems: 'flex-end',
		flexDirection: 'row',
		gap: 10,
	},
	checkpointSignatureImage: {
		maxHeight: 50,
		maxWidth: 50,
		objectFit: 'contain',
		borderBottom: '1 solid black',
	},
	checkpointNonImageAttachmentsWrapper: {
		color: 'black',
		paddingHorizontal: 10,
		marginVertical: 10,
	},
	checkpointNonImageAttachmentsText: {
		paddingVertical: 5,
		paddingHorizontal: 10,
	},
	pageFooterLeft: {
		position: 'absolute',
		fontSize: 12,
		bottom: 30,
		left: 35,
		right: 0,
		textAlign: 'left',
		color: 'grey',
	},
	pageFooterRight: {
		position: 'absolute',
		fontSize: 12,
		bottom: 30,
		left: 0,
		right: 35,
		textAlign: 'right',
		color: 'grey',
	},
	runningHeader: {
		fontSize: 12,
		marginBottom: 20,
		textAlign: 'center',
		color: 'grey',
	},
});
